import type { InboxFolder } from "./useInboxEmails";

export const INBOX_FOLDER_PATHS = [
  "inbox",
  "starred",
  "snoozed",
  "sent",
  "drafts",
  "archive",
  "spam",
  "trash",
] as const satisfies readonly InboxFolder[];

export const LABEL_PATH_PREFIX = "/label/";

export function folderFromPath(pathname: string): InboxFolder {
  const slug = pathname.replace(/^\//, "");
  return (INBOX_FOLDER_PATHS as readonly string[]).includes(slug)
    ? (slug as InboxFolder)
    : "inbox";
}

/** Extrait un label depuis un path `/label/<encodedName>`, sinon null. */
export function labelFromPath(pathname: string): string | null {
  if (!pathname.startsWith(LABEL_PATH_PREFIX)) return null;
  const raw = pathname.slice(LABEL_PATH_PREFIX.length);
  if (raw.length === 0) return null;
  try {
    return decodeURIComponent(raw);
  } catch {
    return raw;
  }
}

/** Slug URL-safe pour un label. Conserve les "/" (hiérarchie Gmail). */
export function labelToPath(label: string): string {
  return `${LABEL_PATH_PREFIX}${label.split("/").map(encodeURIComponent).join("/")}`;
}
